import React, { Component } from 'react'

import { bemClasses } from '../../utils/bem'

class Spacer extends Component {
  componentClassNames = () => {
    return bemClasses('', [], { spacing: this.props })
  }

  render = () => {
    return (
      <span className={this.componentClassNames()}>
        { this.props.children }
      </span>
    )
  }
}

export default Spacer
